@if (loadCardFormNGPG) {
    <div id="card-container"></div>
} @else {
    <form class="form-control-wrapper position-relative" [formGroup]="ccInputFormGroup">
        <mat-form-field hideRequiredMarker>
            <mat-label>
                {{ 'PARTY.CASHIER.web.deposit.cc.cvv.label' | translate }}
            </mat-label>
            <input
                type="text"
                inputmode="numeric"
                pattern="[0-9]*"
                [maxlength]="cvvMaxLength"
                [minlength]="cvvMinLength"
                matInput
                formControlName="cvv2"
                name="cvv2"
                class="form-control"
                formatInput="numbersOnly"
                id="cvv2"
                [(ngModel)]="cvv2"
                onpaste="return false;"
                ondrop="return false;"
                (input)="onCVV2Change()"
                (keypress)="numberOnly($event)"
                [readonly]="depositRedirectService?.popupBlocked" />
            @if (ccInputFormGroup?.controls?.cvv2?.touched || ccInputFormGroup?.controls?.cvv2?.dirty) {
                <mat-error>
                    @if (ccInputFormGroup?.controls?.cvv2?.errors) {
                        <span>{{ 'PARTY.CASHIER.web.deposit.cc.cvv.required3' | translate }} </span>
                    }
                </mat-error>
            }
        </mat-form-field>
        <div class="cvv-tooltip">
            <div class="cvv-icon">
                <img src="./assets/images/cvv.png" alt="" />
            </div>
        </div>

        @if (!(ccInputFormGroup?.controls?.cvv2?.valid || ccInputFormGroup?.controls?.cvv2?.touched || ccInputFormGroup?.controls?.cvv2?.dirty)) {
            <span class="cvv-info-i">
                <span class="theme-info-i info-icon ui-icon ui-icon-size-sm" id="infoIcon" (click)="showCVVTooltip()"></span>
            </span>
        }
    </form>
}

@if (depositRedirectService?.redirectMessage) {
    <div>
        <form
            method="POST"
            name="depositpostredirectform"
            id="depositpostredirectform"
            target="TheWindow"
            action="{{ depositRedirectService?.redirectionUrl }}">
            @if (depositRedirectService?.submitCreq) {
                <span>
                    <input type="hidden" name="creq" value="{{ depositRedirectService?.creq }}" />
                </span>
            }
            @if (depositService.submitJwt) {
                <span>
                    <input type="hidden" name="JWT" value="{{ depositRedirectService?.depositSubmitResponse?.postData.JWT }}" />
                    <input type="hidden" name="MD" value="{{ depositRedirectService?.depositSubmitResponse?.postData.MD }}" />
                </span>
            }
            @if (!(depositRedirectService?.submitCreq || depositService.submitJwt)) {
                <span>
                    <input type="hidden" name="PaReq" value="{{ depositRedirectService?.depositSubmitResponse?.postData?.PaReq }}" />
                    <input type="hidden" name="TermUrl" value="{{ depositRedirectService?.depositSubmitResponse?.redirectionBackUrl }}" />
                    <input type="hidden" name="MD" value="{{ depositRedirectService?.depositSubmitResponse?.postData?.MD }}" />
                </span>
            }
        </form>
    </div>
}
<iframe src="" style="display: none" name="threeDS2redirect" id="threeDS2redirect"></iframe>
@if (isCvvDialogVisible()) {
    <div class="cvv-dialog dialog-overlay-qd">
        <div class="tooltip-content cvv-dialog-content">
            <p class="my-2 mx-3">{{ 'PARTY.CASHIER.web.deposit.cvv.tooltip' | translate }}</p>
            <span class="card-icon"></span>
            <div class="dialog-action-btn mt-2">
                <button type="button" class="btn btn-primary okgotit" (click)="closetooltip()">
                    {{ 'PARTY.CASHIER.web.common.okgotit' | translate }}
                </button>
            </div>
        </div>
    </div>
}
